import request from '../../request';
import { surveyQuestionApi } from './insightsUrls';

export default class surveyQuestionService {
  static async addSurveyQuestion(data) {
    return request({
      url: surveyQuestionApi.addSurveyQuestion(),
      method: 'POST',
      data: data,
    });
  }
  static async addSurveyQuestionRemoveTempId(surveyId, replaceQdId, newQid) {
    return request({
      url: surveyQuestionApi.addSurveyQuestionRemoveTempId(
        surveyId,
        replaceQdId,
        newQid
      ),
      method: 'GET',
    });
  }
  static async post(data) {
    return request({
      url: surveyQuestionApi.post(),
      method: 'POST',
      data: data,
    });
  }

  static async addSurveyQuestionList(data) {
    return request({
      url: surveyQuestionApi.addSurveyQuestionList(),
      method: 'POST',
      data: data,
    });
  }
  static async put(data) {
    return request({
      url: surveyQuestionApi.put(),
      method: 'PUT',
      data: data,
    });
  }

  static async getByToken(token) {
    return request({
      url: surveyQuestionApi.getByToken(),
      method: 'POST',
      data: token,
    });
  }

  static async delete(surveyId, questionId) {
    return request({
      url: surveyQuestionApi.delete(questionId, surveyId),
      method: 'DELETE',
    });
  }

  static async reorderSurveyQuestions(f, t, fIdx, tIdx, sId) {
    return request({
      url: surveyQuestionApi.reorderSurveyQuestions(f, t, fIdx, tIdx, sId),
      method: 'GET',
    });
  }
  //   static async getAll(cId, cType, limit) {
  //     return request({
  //       url: survey.getAll(cId, cType, limit),
  //       method: 'GET',
  //     })
  //   }
}
